import { Form } from '@/hooks/use-form-field';
import { convertEmptyStringsToNull } from '@/schemas/converters';
import { ActionFormProps, FormValues } from '@/constants/formTypes';
import { DynamicRenderer } from './DynamicRenderer';
import { useAction } from '@/hooks/use-action';
import useDynamicForm from '@/hooks/use-dynamic-form';

export function DynamicActionForm({ formData, route }: ActionFormProps) {
  const { isLoading, submit } = useAction();
  const form = useDynamicForm(formData.components);

  function handleFormSubmit(data: FormValues) {
    if (isLoading) {
      return;
    }
    const convertedData = convertEmptyStringsToNull(data);

    submit(formData.action_name, convertedData, route);
  }

  return (
    <Form {...form}>
      <form
        onSubmit={(ev) => void form.handleSubmit(handleFormSubmit)(ev)}
        id={formData.id ?? ''}
      >
        <DynamicRenderer
          form={form}
          components={formData.components}
          route={route}
          submit={handleFormSubmit}
        />
      </form>
    </Form>
  );
}
